import React, { useState } from "react";
import UserCard from "./Discover/UserCard";
import { useVendorProvider } from "../../../Providers/Client/Vendor";
import comingsoon from "../../../Assets/comingsoon.png"

export default function Discover() {
  const [searchText, setSearchText] = useState("");
  const [userList, setUserList] = useState([]);
  const { searchUser } = useVendorProvider();
  const handleChange = (e) => {
    setSearchText(e.target.value);
  };

  const search = () => {
    searchUser(searchText)
      .then((res) => {
        setUserList(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div className="py-4 px-8 font-[Roboto] flex justify-center bg-white rounded-lg shadow-md shadow-gray-400">
      <img alt="coming soon" className="h-[99%] w-[60%]" src={comingsoon} />
      {/* <div>
        <span>Find Consultants or Vendors</span>
        <div className="flex md:flex-row flex-col md:space-x-2 md:space-y-0 space-y-2 md:mb-8">
          <input
            className="border-[1px] border-[#C6C6C6] border-solid"
            placeholder="Type Here..."
            onChange={handleChange}
            style={{
              // border: "1px solid #C6C6C6",
              borderRadius: "4px",
              width: "100%",
              height: "45px",
              paddingLeft: "10px",
            }}
          />
          <button
            style={{
              width: "168px",
              height: "45px",
              background: "#139588",
              border: "1px solid #C6C6C6",
              borderRadius: "4px",
              color: "white",
            }}
            onClick={search}
          >
            Search
          </button>
        </div> */}
      {/* <div className="flex min-[1120px]:flex-row flex-col max-[1120px]:space-y-4 min-[1120px]:space-x-8 justify-start mt-4">
          <div className="flex flex-col">
            <span className="mb-2">Project</span>
            <Space wrap>
              <Select
                defaultValue="Select Project"                                           
                style={{ width: 280 }}
                //onChange={handleChange}
                options={[
                  { value: 'Project1', label: 'Project1' },
                  { value: 'Project2', label: 'Project2' },
                  { value: 'Project3', label: 'Project3' },
                  { value: 'Project4', label: 'Project4', disabled: true },
                ]}
              />
            </Space>
          </div>
          <div className="flex flex-col">
            <span className="mb-2">Job</span>
            <Select
              defaultValue="Select Job"
              style={{ width: 280 }}
              //onChange={handleChange}
              options={[
                { value: 'Job1', label: 'Job1' },
                { value: 'Job2', label: 'Job2' },
                { value: 'Job3', label: 'Job3' },
                { value: 'Job4', label: 'Job4', disabled: true },
              ]}
            />
          </div>
        </div> */}
      {/* </div> */}
      {/* {userList.length > 0 ? (
        <div className="mt-8">
          <span>List Of Users</span>
          {userList.map((user, index) => {
            return <UserCard details={user} />;
          })}
        </div>
      ) : null} */}
    </div>
  );
}
